import React, { useCallback } from 'react';
import styled from 'styled-components';
import { MemberBanner } from '@parchment/ui-primitives';
import { FormContainer, FormHeader, mercury } from '@parchment/atoms';

export default function BaseLayout ({
    titleText = '',
    leftComponent = null,
    rightComponent = null,
    children = null,
    showMemberBanner = true,
    showFooter = true
}) {
    const memberBannerProps = {
        bannerText: '',
        imageBaseUrl: window.location.origin
    };

    const getMember = () => {
        let member =  window.config.member;
        const memberDirectoryMember = window.config.memberServiceDirectoryMemberInfo;
        const memberDirectorySendService = memberDirectoryMember?.services?.find(service => service.name === 'SEND');
        if(memberDirectorySendService) {
            member.name = memberDirectorySendService.displayName;
        }
        return member;
    }

    const BannerContainer = window.config.member?.name && useCallback(() => {
        return (
            <FormContainer context='ghost'
                           bodyType={FormContainer.BasicBody}
                           className='form-banner'>
                <MemberBanner member={getMember()} {...memberBannerProps} />
            </FormContainer>
        )
    }, []);
    if (BannerContainer) {
        BannerContainer.displayName = 'BannerContainer';
    }

    return (
        <div className='unified-registration-page'>
            <StyledFormHeader context='light'
                              className='form-header'
                              left={leftComponent}
                              right={rightComponent}>{titleText}</StyledFormHeader>
            { showMemberBanner && window.config.member?.name && <BannerContainer /> }
            { children }
            {
                showFooter &&
                    <FooterSection context='light'
                                   className='footer-section'>
                        <div className='terms-footer'>
                            <div>By signing up you agree to the Parchment <a href='https://www.parchment.com/terms-of-use' target='_blank'>terms of use</a> and <a href='https://www.parchment.com/privacy-policy' target='_blank'>privacy policy</a>.</div>
                        </div>
                    </FooterSection>
            }
        </div>
    );
}

const StyledFormHeader = styled(FormHeader)`
    font-size: 20px;
    font-weight: 600;
`;
StyledFormHeader.displayName = 'StyledFormHeader';

const FooterSection = styled(FormContainer)`
    background-color: ${mercury};
`;
FooterSection.displayName = 'FooterSection';
